import React, { FC } from 'react';
import { Box, Link, Tooltip, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSocialConnections } from 'hooks';
import { RemoveIcon } from 'components';
import { LinkedInPage, useBatchUpdateSocialConnectionMutation } from 'api';
import useUpdateSocialConnection from 'updaters/useUpdateSocialConnection';
import { isEqual } from 'lodash';

const styles = {
  root: {
    padding: 0,
  },
  tooltip: {
    padding: 2,
  },
} as const;

interface Props {
  accountId: string;
}

const LinkedInPages: FC<Props> = ({ accountId }) => {
  const { t } = useTranslation();
  const { linkedInPages } = useSocialConnections();

  const updateMutationOptions = useUpdateSocialConnection();
  const { mutate } = useBatchUpdateSocialConnectionMutation(updateMutationOptions);

  if (!linkedInPages?.length) {
    return null;
  }

  const filteredPages: LinkedInPage[] = linkedInPages.filter(page => page.id === accountId);

  function onClick(page: LinkedInPage) {
    const linkedin_pages = filteredPages.filter(item => !isEqual(item, page));
    mutate({
      data: { items: [{ token_id: accountId, linkedin_pages }] },
    });
  }

  return (
    <Box paddingLeft="44px" marginTop={1}>
      {filteredPages.map(page => (
        <Box key={page.identifier} marginBottom={1}>
          <Grid container alignItems="center" spacing={1}>
            <Grid>
              <Tooltip
                arrow
                title={t('help:account_social_connections')}
                placement="top"
                sx={{ tooltip: styles.tooltip }}
              >
                <Box>
                  <RemoveIcon onClick={() => onClick(page)} lighter sx={{ root: styles.root }} />
                </Box>
              </Tooltip>
            </Grid>

            <Grid>
              <Link
                display="block"
                target="_blank"
                href={page.profile_url}
                color="textSecondary"
                underline="hover"
              >
                {page.profile_name}
              </Link>
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default LinkedInPages;
